import { WHOLESALE_DETAIL_GETTERs } from "@/store/storeConstants"

export default {
    [WHOLESALE_DETAIL_GETTERs]:(state)=>{
        return state.wholeSaleDetail
    }
  
}